import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../client';
import { qk } from './keys';
import type {
  SafetyScore,
  SafetyScoreBreakdown,
  SafetyScoreHistoryPoint,
} from '../types';

export function useSafetyCurrent(enabled = true) {
  return useQuery({
    queryKey: qk.safetyCurrent,
    queryFn: async () => {
      try {
        return await apiGet<SafetyScore>('/safety-score/me/current');
      } catch {
        return null;
      }
    },
    refetchInterval: 60_000,
    enabled,
  });
}

export function useSafetyBreakdown() {
  return useQuery({
    queryKey: qk.safetyBreakdown,
    queryFn: async () => {
      try {
        return await apiGet<SafetyScoreBreakdown>('/safety-score/me/breakdown');
      } catch {
        return null;
      }
    },
  });
}

export function useSafetyHistory(days = 30) {
  return useQuery({
    queryKey: qk.safetyHistory(days),
    queryFn: async () => {
      // 404 = current_location is not set (backend P0). Don't crash —
      // home shows a "set your location" prompt instead.
      try {
        return await apiGet<SafetyScoreHistoryPoint[]>(`/safety-score/me/history?days=${days}`);
      } catch {
        return null;
      }
    },
  });
}

export function useSafetyByCountry(code: string | null) {
  return useQuery({
    queryKey: qk.safetyByCountry(code ?? ''),
    queryFn: () => apiGet<SafetyScore>(`/safety-score/by-country/${code ?? ''}`),
    enabled: !!code,
  });
}
